import {Component} from 'react';
import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import documentService from '../../services/document/DocumentService';
import authenticationService from '../../services/authentication/AuthenticationService';
import ReadOnlyDocumentsList from '../../components/readOnlyDocumentList';
import {openOrSaveFile} from '../../utils/http';
import {getLegalDocuments, getBusinessDocuments, getProjectDocuments, getAdditionalDocuments} from '../../utils/document';

export class DocumentListReadOnlyView extends Component {
  constructor(props) {
    super(props);

    this.handleDocumentFileOpen = this.handleDocumentFileOpen.bind(this);
    this.handleDocumentProofFileOpen = this.handleDocumentProofFileOpen.bind(this);
  }

  handleDocumentFileOpen(document) {
    authenticationService.authRedirect(documentService.getFileUrl(document.uid))
      .then(authUrl => openOrSaveFile(authUrl));
  }

  handleDocumentProofFileOpen(document) {
    authenticationService.authRedirect(documentService.getFileProofUrl(document.uid))
      .then(authUrl => openOrSaveFile(authUrl));
  }

  render() {
    const legalDocuments = getLegalDocuments(this.props.documents);
    const businessDocuments = getBusinessDocuments(this.props.documents);
    const additionalDocuments = getAdditionalDocuments(this.props.documents);
    const projectDocuments = getProjectDocuments(this.props.documents);

    return this.props.documentsError ? (<span><Translate value="error.generic"/></span>) :
      (<>
        { legalDocuments.length > 0 &&
      <div className={this.props.documentsSelected ? '' : 'card'}>
        <div className="card-header">
          <div className="card-title"><Translate value="dossier.labels.LEGAL"/></div>
        </div>
        <ReadOnlyDocumentsList
          documents={legalDocuments}
          onDocumentFileOpen={this.handleDocumentFileOpen}
          onDocumentProofFileOpen={this.handleDocumentProofFileOpen}
          loading={this.props.documentsLoading}
          documentsSelected={this.props.documentsSelected}
          onCheckEvent={this.props.onCheckEvent}
          allowDownload
        />
      </div>}

        { businessDocuments.length > 0 &&
      <div className={this.props.documentsSelected ? 'mt-5' : 'card'}>
        <div className="card-header">
          <div className="card-title"><Translate value={'dossier.labels.BUSINESS.ALL'}/></div>
        </div>
        <ReadOnlyDocumentsList
          documents={businessDocuments}
          onDocumentFileOpen={this.handleDocumentFileOpen}
          onDocumentProofFileOpen={this.handleDocumentProofFileOpen}
          loading={this.props.documentsLoading}
          documentsSelected={this.props.documentsSelected}
          onCheckEvent={this.props.onCheckEvent}
          allowDownload
        />
      </div>}

        { additionalDocuments.length > 0 &&
      <div className={this.props.documentsSelected ? 'mt-5' : 'card'}>
        <div className="card-header">
          <div className="card-title"><Translate value="dossier.labels.ADDITIONAL"/></div>
        </div>
        <ReadOnlyDocumentsList
          documents={additionalDocuments}
          onDocumentFileOpen={this.handleDocumentFileOpen}
          onDocumentProofFileOpen={this.handleDocumentProofFileOpen}
          loading={this.props.documentsLoading}
          documentsSelected={this.props.documentsSelected}
          onCheckEvent={this.props.onCheckEvent}
          allowDownload
        />
      </div>}

        { projectDocuments.length > 0 &&
      <div className={this.props.documentsSelected ? 'mt-5' : 'card'}>
        <div className="card-header">
          <div className="card-title"><Translate value="dossier.labels.PROJECT"/></div>
        </div>
        <ReadOnlyDocumentsList
          documents={projectDocuments}
          onDocumentFileOpen={this.handleDocumentFileOpen}
          onDocumentProofFileOpen={this.handleDocumentProofFileOpen}
          loading={this.props.documentsLoading}
          documentsSelected={this.props.documentsSelected}
          onCheckEvent={this.props.onCheckEvent}
          allowDownload
        />
      </div>}
      </>);
  }
}

DocumentListReadOnlyView.defaultProps = {
  documents: [],
  documentsLoading: false,
  documentsError: false
};

DocumentListReadOnlyView.propTypes = {
  documents: PropTypes.array,
  documentsLoading: PropTypes.bool,
  documentsError: PropTypes.bool,
  documentsSelected: PropTypes.array,
  onCheckEvent: PropTypes.func
};

export default DocumentListReadOnlyView;
